import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import Badge from '@material-ui/core/Badge';


const useStyles = createStyles({
  "MuiBadge-colorSecondary": "orange"
}, { name: 'MuiBadge' });

const styles = theme => ({
  root: {
    margin: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    ".MuiBadge-colorSecondary": {
      color: "orange"
    }
  },
  padding: {
    padding: theme.spacing(0, 2),
  },
  fullWidth: {
    width: "100%"
  }
});

class FormField extends Component {
  state = { value: "", dirty: false, errors: [] };

  hasChanged = e => {
    e.preventDefault();

    const {
      label,
      required = false,
      validator = f => f,
      onStateChanged = f => f
    } = this.props;

    const value = e.target.value;
    const isEmpty = value.length === 0;
    const requiredMissing = this.state.dirty && required && isEmpty;

    let errors = [];

    if (requiredMissing) {
      errors = [...errors, `${label} is required`];
    } else if ("function" === typeof validator) {
      try {
        validator(value);
      } catch (e) {
        errors = [...errors, e.message];
      }
    }

    this.setState(
      ({ dirty = false }) => ({ value, errors, dirty: !dirty || dirty }),
      () => onStateChanged(this.state)
    );
  };

  render() {
    const { value, dirty, errors } = this.state;
    const { badgeColor, badgeContent, classes, type, label, fieldId, placeholder, children } = this.props;

    const hasErrors = errors.length > 0;
    const controlClass = [
      "form-control",
      dirty ? (hasErrors ? "is-invalid" : "is-valid") : ""
    ]
      .join(" ")
      .trim();

    return (
      <Fragment>
        <div className="form-group">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <label htmlFor={fieldId} className="control-label">
              {label}
            </label>
            {hasErrors && (
              <div className="error form-hint font-weight-bold text-right m-0 mb-2">
                {errors[0]}
              </div>
            )}
          </div>
          {children}

          <Badge badgeContent={badgeContent} invisible={badgeContent === ""} color={badgeColor} className={classes.root}>
          <TextField
            type={type}
            className={controlClass}
            fullWidth
            id={fieldId}
            placeholder={placeholder}
            value={value}
            onChange={this.hasChanged}
          />
          </Badge>
        </div>
      </Fragment>
    );
  }
}

FormField.propTypes = {
  type: PropTypes.oneOf(["text", "password"]).isRequired,
  label: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  children: PropTypes.node,
  validator: PropTypes.func,
  onStateChanged: PropTypes.func
};

export default withStyles(styles)(FormField);